import { Modal } from 'antd';
import { media } from 'responsive/media';
import styled, { css } from 'styled-components';

export const ModalWrapper = styled(Modal)`
  &.info-user-modal,
  &.new-student-register-modal {
    animation: infoUserModalFadeIn 160ms ease-out;
    will-change: transform, opacity;
    .ant-modal-content {
      will-change: transform, opacity;
      transition: none !important;
    }
    .ant-modal-body {
      scroll-behavior: auto;
      transition: none !important;
    }
  }

  @keyframes infoUserModalFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .ant-modal-content {
    padding: 0;
    width: ${(prop) => `${prop.width}px` || '679px'};
    height: auto !important;
    min-height: ${(props) => `${props.height}px` || '412px'} !important;
    position: relative;

     ${media.xxlDown(css`
       max-height: 730px;
     `)}

   ${media.xlDown(css`
     max-height: 660px;
   `)}

  .ant-modal-title {
    color: white;
    font-style: normal;
    font-weight: 700 !important;

   
  }

  .ant-modal-close {
    margin-right: 8px;
    margin-top: 8px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-modal-close-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-modal-close {
    color: #fff;
    .ant-modal-close-icon {
      width: 24px;
      height: 24px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
  .ant-form-item-label > label {
    align-items: flex-start !important;
  }

  .ant-modal-header {
    height: ${(props) =>
      props.heightHeader ? `${props.heightHeader}px` : '54px'};
    font-style: normal;
    font-weight: 700;
    display : flex;
    align-items : center;
    padding : 0 20px;
    margin: 0;
    background: #ed7836;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    

    .ant-modal-close {
      width: 12px;
      height: 12px;
    }

    .ant-modal-close-x {
      width: 24px;
      height: 24px;
    }

    .ant-modal-close-x .anticon {
      width: 24px;
      height: 24px;
    }
  }

  .ant-modal-body {
    background: #fff;
    width: 100%;
    max-height: 720px !important;
    overflow-y: auto;
    overflow-x: hidden;
    overflow-anchor: none;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: ${(props) =>
      Array.isArray(props.padding)
        ? props.padding.map((p) => `${p}px`).join(' ')
        : props.padding || '24px'};
    gap: 20px;
    display: flex;
    flex-direction: column;

     ${media.xxlDown(css`
       max-height: 590px !important;
     `)}

   ${media.xlDown(css`
     max-height: 530px !important;
   `)}

  .ant-form-item {
    transition: all 0.3s ease-in-out;
    margin-bottom: 0;
  }

  .ant-form-item-has-error {
    margin-bottom: 24px !important;
    transition: margin-bottom 0.3s ease-in-out;
  }

  .ant-form-item-explain-error {
    margin-top: 4px;
    margin-bottom: 8px;
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
  }

  .ant-form-item-has-error .ant-form-item-explain-error {
    opacity: 1;
    max-height: 50px;
    transition: all 0.3s ease-in-out;
  }

  .ant-modal-content {
    transition:
      height 0.3s ease-in-out,
      min-height 0.3s ease-in-out;
  }

  .ant-modal-body {
    position: relative;
    z-index: 500;
    transition: height 0.3s ease-in-out;
  }

  .ant-modal-footer {
    margin: 0;
    position: relative;
    z-index: 1000;
    padding : 20px 16px;
  }

  .ant-form-item-label > label {
    height: 22px;
    color: black;
    align-items: center !important;
  }

  .ant-form-item-control-input {
    height: 22px !important;
    min-height: 22px !important;
  }
  .ant-row {
    width: 100%;
    height: max-content;
    gap: 20px;
  }

  .ant-col {
    height: auto;
    min-height: fit-content;
  }

  .ant-form-item {
    margin-bottom: 0;
    height: auto;
    min-height: 22px;
  }

  .ant-form-item:not(:has(.ant-input)):not(:has(.ant-input-password)) {
    height: 22px;
  }
  .ant-form-item:has(.ant-input),
  .ant-form-item:has(.ant-input-password) {
    height: auto;
    min-height: 39px;
  }

  .ant-form-item:has(.ant-input) .ant-form-item-label,
  .ant-form-item:has(.ant-input-password) .ant-form-item-label {
    display: flex;
    align-items: center;
    height: 39px;
    padding: 0;
  }

  .ant-form-item:has(.ant-input) .ant-form-item-label > label,
  .ant-form-item:has(.ant-input-password) .ant-form-item-label > label {
    height: auto;
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
  }

  .ant-form-item .ant-form-item-control-input {
    height: 22px !important;
    min-height: 22px !important;
  }

  .ant-form-item .ant-form-item-control-input:has(.ant-input),
  .ant-form-item .ant-form-item-control-input:has(.ant-input-password) {
    height: 39px !important;
    min-height: 39px !important;
  }
`;
